import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import i18n from "i18next";
// import { useTranslation, initReactI18next } from "react-i18next";
import { initReactI18next } from "react-i18next";
import tEN from './locales/en/transaltion.json'
import tAR from './locales/ar/transaltion.json'


i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: tEN
      },
      ar: {
        translation: tAR
      }
    },
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

  // function App() {
  //   const { t } = useTranslation();
  //   return <h2>{t('login')}</h2>;
  // }



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


